export default class SignupTracking {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    getElements = () => {
    }

    addEventListeners = () => {
        this.passedElement.addEventListener('click', (event) => {
            if (!window.lintrk) {
              return;
            }
            event.preventDefault();
            const link = {
                url : event.target.getAttribute('href'),
                target : event.target.getAttribute('target') ? event.target.getAttribute('target') : '_self',
            };
            window.lintrk('track', { conversion_id: 8685930 });
            window.open(link.url, link.target);
        });
    }

}